export const fittsLaw = `const config = {
  formulas: [
    {
      id: "fitts-law",
      latex: "T_1 = a + b \\\\log \\\\left( \\\\frac{2D}{W} \\\\right)"
    },
    {
      id: "fitts-law-two",
      latex: "T_2 = a + c \\\\log \\\\left( \\\\frac{2D}{W} \\\\right)"
    }
  ],
  variables: {
    T_1: {},
    T_2: {},
    a: 0.1,
    b: 0.3,
    c: 0.5,
    D: {
      input: "drag",
      default: 5,
      range: [1, 20],
      name: "Distance"
    },
    W: {
      input: "drag",
      default: 1,
      range: [0.1, 10],
      name: "Width"
    }
  },
  semantics: function({ vars, sample }) {
    vars.T_1 = vars.a + vars.b * Math.log((2 * vars.D) / vars.W);
    vars.T_2 = vars.a + vars.c * Math.log((2 * vars.D) / vars.W);
    sample("fitts_1", {x: vars.W, y: vars.T_1});
    sample("fitts_2", {x: vars.W, y: vars.T_2});
  },
  graph2d: [{
    id: "fittsGraph",
    xAxisLabel: "W",
    xAxisVar: "W",
    xRange: [0.1, 10],
    yAxisLabel: "T",
    yAxisVar: "T_1",
    yRange: [0, 3],
    lines: [
      {
        sampleId: "fitts_1",
        parameter: "W",
        name: "Fitts Law",
        interaction: ["vertical-drag", "D"]
      },
      {
        sampleId: "fitts_2",
        parameter: "W",
        name: "Fitts Law",
        interaction: ["vertical-drag", "D"]
      }
    ],
    points: [
      {
        sampleId: "fitts_1",
        interaction: ["horizontal-drag", "W"]
      },
      {
        sampleId: "fitts_2",
        interaction: ["horizontal-drag", "W"]
      }
    ]
  }]
};`;
